import React, { Fragment, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import { Col, Modal, Row } from "react-bootstrap";
import { useFormik } from "formik";
import { Button } from "../../common/Button";
import SelectFiled from "../../common/textfield/SelectFiled";
import Fields from "./Fields";
import { getOrganization, getOrganizationSettings } from "../../api/Organization";
import { useSelector } from "react-redux";
import { failed, success } from "../../common/Toastify";
import { axios } from "../../../lib/axios";
import { FormikObjInboundCall } from "./Constant";
import moment from "moment";
import PatientSelection from "./PatientSelection";
import AddPatient from "./AddPatient";
import { useNavigate } from "react-router-dom";
import { editEncounter } from "../../apps/api/AppointmentRequests";
import { generatePass } from "../../apps/AppointmentRequests/Constants";
import { createQuestionnaireResponse, editQuestionnaireResponse, getQuestionnaireById } from "../../api/Questionnaire";
import { evaluateCondition } from "../../../utils/questionnaireSupport";
import BookAppointment from "../../apps/AppointmentRequests/BookAppointment";
import { getSingleUser, updatePatientDemographics, createExternalRegistryUser } from "../../api/Individual";
import { LOCATIONS } from "../../common/location";
import AddToWaitingRoomModal from "./AddToWaitingRoomModal";
import { getServiceLineById, getServiceLinesByOrgId } from "../../api/ServiceLine";
import { useGetOrgLicensedProducts } from "../../../hooks/ReactQueryHooks/useGetOrgLicensedProducts";
import { useConfirmDialog } from "../../../hooks/useConfirmDialog";
import { createEncounterInbound } from "../../apps/api/AppointmentRequests";

const steps = [
  "Select Organization",
  "Intake Questionnaire",
  "Patient Selection",
  "How to proceed?",
];
export const genderOptions = [
  { value: "male", name: "Male" },
  { value: "female", name: "Female" },
  { value: "other", name: "Other" },
];

export default function InBoundCall({
  encounterId: incomingEncounterId = null,
  encounteredData: incomingEncounterData = null,
  modalShow,
  handleShow,
  selectedPractitionerId=null,
}) {
  const user = useSelector((state) => state?.auth?.user);
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [isOrgReadOnly, setisOrgReadOnly] = useState(incomingEncounterId ? true : false);
  const [activeStep, setActiveStep] = useState(0);
  const [patientModal, setPatientModal] = useState(false);
  const [skipped, setSkipped] = useState(new Set());
  const [Questions, setQuestions] = useState([]);
  const [questionnaireDefinition, setQuestionnaireDefinition] = useState(null);
  const [visibleQuestions, setVisibleQuestions] = useState([]);
  const [questionResponseKey, setQuestionResponseKey] = useState(0);
  const [isWaitingRoom, setIsWaitingRoom] = useState(null);
  const [organizations, setOrganizations] = useState([]);
  const [appointmentModal, setAppointmentModal] = useState(false);
  const [radioValue, setRadioValue] = useState([]);
  const [patient, setPatient] = useState(null);
  const [questionnairResId, setQuestionnairResId] = useState("");
  const [practitionerData, setPractitionerData] = useState(null);
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations);
  const [addToWRModalShow, setAddToWRModalShow] = useState(false);
  const [WRModalData, setWRModalData] = useState(null);
  const [availableServiceLines, setAvailableServiceLines] = useState([]);
  const { data: orgLicensedProducts } = useGetOrgLicensedProducts({})
  const is_VirtualCareEnabled = orgLicensedProducts?.virtualCare
  const { getConfirmation } = useConfirmDialog();
  const [encounterId, setEncounterId] = useState(incomingEncounterId);
  const [encounteredData, setEncounteredData] = useState(incomingEncounterData);
  const [organizationSettings, setOrganizationSettings] = useState(null);
  const formik = useFormik({
    ...FormikObjInboundCall,
    enableReinitialize: true,
    onSubmit: (values, { setFieldError }) => {
      let topic = user?.name[0]?.text?.toLowerCase() + "fonemed";
      topic = topic.replace(" ", "") + Math.round(new Date().getTime() / 1000);
      let password = generatePass();
      if (activeStep === 0) {
        if (values?.orgId === "") {
          setFieldError(`orgId`, "Required field");
          return true;
        } else if (values?.serviceLineId === "") {
          setFieldError(`serviceLineId`, "Required field")
          return true;
        } else {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
        if(!encounterId) {
          let encounterPayload = {
            orgId: values?.orgId,
            orgName: values?.orgName.trim(),
            requestedPeriod: {start: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"), end: null},
            practitionerId: practitionerData?.link?.[0]?.target?.reference?.split("/")?.[1],
            practitionerName: practitionerData?.name?.[0]?.text.trim(),
            status: "in-progress-intake",
            statusHistory: [{
                status: "in-progress-intake",
                actor: {
                    reference: practitionerData?.link?.[0]?.target?.reference,
                    display: practitionerData?.name?.[0]?.text,
                },
                period: {
                    start: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
                    end: null
                }
            }] 
          }
          createEncounterInbound(encounterPayload).then((res)=>{
              if(res.status === true){ 
                setEncounterId(res.data.id); 
                setEncounteredData(res.data);
                setisOrgReadOnly(true);
              }else{
                failed(res?.response?.data?.message || res?.response?.data?.error || res.message) 
              }
          }).catch((res) => { 
              failed(res?.response?.data?.message || res?.response?.data?.error || res.message)
          }).finally();
        } else {
          setisOrgReadOnly(true);
        }
      } else if (activeStep === 1) {
        const telePhoneField = formik?.values?.questionResponse?.find(
          (item) => item?.tag === "TELEPHONE"
        )?.answer?.[0]?.answer;
        const pattern =
          /^(?:\+?1[-. ]?)?\(?[0-9]\d{2}\)?[-. ]?\d{3}[-. ]?\d{4}$/;
        const errList = values?.questionResponse?.map((question, index) => {
          if (visibleQuestions[index] && question?.required) {
            if (question?.answerType === "radio") {
              if (!question?.answer?.some((item) => !!item?.answer)) {
                setFieldError(`questionResponse[${index}]`, "Required field");
                return true;
              }
            } else if (
              question?.answerType === "freeText" ||
              question?.answerType === "singleFreeText" ||
              question?.answerType === "dropDown"
            ) {
              // if (question?.answer?.[0]?.answer?.length < 1 || !question?.answer?.[0]?.answer?.replace(/\s/g, "").length || question?.answer?.[1]?.answer?.length < 1 || !question?.answer?.[1]?.answer?.replace(/\s/g, "").length) {
              if (
                question.tag === "RELATIONSHIP" &&
                question?.answerType === "dropDown"
              ) {
                if (
                  question?.answer[0]?.answer === "" &&
                  radioValue.some(
                    (option) =>
                      option?.answer === true && option?.option === "No"
                  )
                ) {
                  setFieldError(`questionResponse[${index}]`, "Required field");
                  return true;
                }
              } else if (
                question.tag !== "RELATIONSHIP" &&
                question?.answerType === "dropDown" &&
                question?.answer[0]?.answer === ""
              ) {
                setFieldError(`questionResponse[${index}]`, "Required field");
                return true;
              }
              if (
                (question?.answerType === "freeText" || question?.answerType === "singleFreeText") &&
                question?.tag === "CALLER"
              ) {
                if (
                  question?.answer?.[0]?.answer === "" ||
                  question?.answer?.[0]?.answer === undefined
                ) {
                  setFieldError(`questionResponse[${index}]`, "Required field");
                  return true;
                }
                if (
                  question?.answer?.[1]?.answer === "" ||
                  question?.answer?.[1]?.answer === undefined
                ) {
                  setFieldError(`questionResponse[${index}]`, "Required field");
                  return true;
                }
              } else if (
                (question?.answerType === "freeText" || question?.answerType === "singleFreeText") &&
                question?.tag !== "CALLER"
              ) {
                if (
                  question?.answer?.[0]?.answer === "" ||
                  question?.answer?.[0]?.answer === undefined
                ) {
                  setFieldError(`questionResponse[${index}]`, "Required field");
                  return true;
                }
              }

              const firstName = values?.questionResponse.find(
                (obj) => obj.tag === "CALLER"
              )?.answer?.[0]?.answer;
              const lastName = values?.questionResponse.find(
                (obj) => obj.tag === "CALLER"
              )?.answer?.[1]?.answer;
              const indexAnswer = values?.questionResponse.findIndex(
                (obj) => obj.tag === "CALLER"
              );
              if (
                firstName === "" ||
                lastName === undefined ||
                lastName === ""
              ) {
                setFieldError(
                  `questionResponse[${indexAnswer}]`,
                  "Required field"
                );
                return true;
              }
              // }
            } else if (question?.answerType === "checkbox") {
              if (!question?.answer?.some((item) => !!item?.answer)) {
                setFieldError(`questionResponse[${index}]`, "Required field");
                return true;
              }
            }
          }
          return false;
        });

        if (
          formik?.values?.questionResponse?.length === 0 ||
          formik?.values?.questionResponse?.length === undefined ||
          formik?.values?.questionResponse?.length === null
        ) {
          return true;
        }
        if (!pattern.test(telePhoneField)) {
          return true;
        }

        if (!errList?.includes(true)) {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }

        localStorage.setItem(
          "firstName",
          values?.questionResponse.find((obj) => obj.tag === "CALLER")
            ?.answer?.[0]?.answer
        );
        localStorage.setItem(
          "lastName",
          values?.questionResponse.find((obj) => obj.tag === "CALLER")
            ?.answer?.[1]?.answer
        );
      } else if (activeStep === 2) {
        if (values?.patientId === "" && values?.selectedPatientData === "") {
          setFieldError(`patientId`, "Select patient before proceeding");
          return true;
        } else {
          // Check if selected organization has ecrEnabled ===true
          const selectedPatientData = values?.selectedPatientData;
          
          if (selectedPatientData && organizationSettings?.ecrEnabled === true) {
            if (selectedPatientData?.source && selectedPatientData?.source.includes("EXT") && selectedPatientData?.source.includes("FLZ")) {
              // Update patient demographics
              setBtnLoading(true);
              
              // Format birthDate to MM-DD-YYYY
              const dob = moment(selectedPatientData?.birthDate).format("MM-DD-YYYY");
              
              const payload = {
                birthDate: (dob !== "Invalid date") ? dob : "",
                firstName: selectedPatientData?.name?.[0]?.given?.[0].trim() || "",
                lastName: selectedPatientData?.name?.[0]?.family.trim() || "",
                gender: selectedPatientData?.gender.trim() || "",
                managingOrganization: values?.orgId,
                telecom: selectedPatientData?.telecom || [],
                address: selectedPatientData?.address || [],
                identifier: selectedPatientData?.identifier ? selectedPatientData?.identifier : [],
                source: "EXT"
              };

              updatePatientDemographics(values?.patientId, values?.orgId, payload)
                .then((res) => {
                  if (res?.status === true) {
                    success(res?.message || "Patient demographics updated successfully");
                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                  } else {
                    failed(res?.error || "Failed to update patient demographics");
                  }
                })
                .catch((res) => {
                  failed(
                    res?.response?.data?.message ||
                    res?.response?.data?.error ||
                    res?.message ||
                    "Error updating patient demographics"
                  );
                })
                .finally(() => setBtnLoading(false));
            } else if (selectedPatientData?.source?.length === 1 && selectedPatientData?.source?.includes("EXT")) {
              // Create user account
              setBtnLoading(true);
              const email = selectedPatientData?.telecom?.find((t) => t?.system === "email")?.value || "";
              const firstIdentifier = selectedPatientData?.identifier?.[0];
              const cleanedIdentifier = firstIdentifier ? (() => {
                const { source, ...identifierWithoutSource } = firstIdentifier;
                return [{
                  ...identifierWithoutSource,
                  type: "HCN"
                }];
              })() : [];
              
              const payload = {
                type: "Patient",
                name: selectedPatientData?.name,
                gender: selectedPatientData?.gender?.trim() || "",
                birthDate: selectedPatientData?.birthDate,
                telecom: selectedPatientData?.telecom,
                address: selectedPatientData?.address,
                managingOrganization: values?.orgId,
                identifier: cleanedIdentifier,
                email: email?.trim(),
                createAccount: false,
                source: "EXT",
              };

              createExternalRegistryUser(
                payload,
                values?.orgId,
                organizations
              )
                .then((res) => {
                  if (res?.status === true) {
                    success(res?.message || "User account created successfully");
                    formik.setFieldValue("patientId", res?.data?.link[0]?.target?.reference?.split("/")?.[1] || "");
                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                  } else {
                    failed(res?.error || "Failed to create user account");
                  }
                })
                .catch((res) => {
                  failed(
                    res?.response?.data?.message ||
                    res?.response?.data?.error ||
                    res?.message ||
                    "Error creating user account"
                  );
                })
                .finally(() => setBtnLoading(false));
            }else{
              // Patient is Florizel, proceed normally
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
          } else {
            // Patient is not EXTERNAL, proceed normally
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
          }
        }
      } else if (activeStep === 3) {
        if (values.howToProcced === "") {
          setFieldError(`howToProcced`, "Required field");
          return true;
        } else {
          const requestedPeriod = [
            {
              start: moment().format("YYYY-MM-DDTHH:mm:ss[Z]"),
              end: moment().format("YYYY-MM-DDTHH:mm:ss[Z]"),
            },
          ];
          const getLocationQuestion = values.questionResponse.find(
            (question) => question.tag === "LOCATION"
          );
          let location = getLocationQuestion?.answer?.[0]?.answer;
          let scopeOfJurisdiction = LOCATIONS[location];
          if (!scopeOfJurisdiction) {
            scopeOfJurisdiction = location;
          }
          if (values?.howToProcced === "COMPLETE_CALL") {
            setBtnLoading(true);
            let concatenatedAnswerExt;
            let telephoneAnswer;
            let concatenatedName;
            let nameAnswer;
            const nameQuestion = values.questionResponse.find(
              (question) => question.tag === "CALLER"
            );
            if (nameQuestion) {
              nameAnswer = nameQuestion?.answer;
              concatenatedName =
                nameQuestion?.answer?.[1] !== undefined
                  ? nameAnswer[0]?.answer + " " + nameAnswer[1]?.answer
                  : nameAnswer[0]?.answer;
              let namePatient =
                getValueQuestionnairRadio("SELFCALLING") === "Yes"
                  ? values?.patientName
                  : concatenatedName;
              nameAnswer.splice(1, 1);
              nameAnswer[0].answer = namePatient
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");
              nameAnswer[0].required = true;
              nameAnswer[0].option = null;
              nameAnswer[0].value = null;
              nameAnswer[0].name = null;
            }
            const telephoneQuestion = values.questionResponse.find(
              (question) => question.tag === "TELEPHONE"
            );
            if (telephoneQuestion) {
              telephoneAnswer = telephoneQuestion?.answer;
              concatenatedAnswerExt =
                telephoneQuestion?.answer?.[1] !== undefined
                  ? telephoneAnswer[0]?.answer +
                    " ext " +
                    telephoneAnswer[1]?.answer
                  : telephoneAnswer[0]?.answer;
              telephoneAnswer.splice(1, 1);
              telephoneAnswer[0].answer = concatenatedAnswerExt;
              telephoneAnswer[0].required = true;
              telephoneAnswer[0].option = null;
              telephoneAnswer[0].value = null;
              telephoneAnswer[0].name = null;
            }
            const questionResponse = values.questionResponse?.map((item) => ({
              id: item?.linkId,
              tag: item?.tag,
              questionId: item?.id || null,
              question: item?.text.trim(),
              answer: (item?.tag === "TELEPHONE" ? telephoneAnswer : item.answer),
              questionType: item?.answerType,
              required: item?.required,
            }));
            let payload = {
              patientID: values.patientId,
              encounterId: "",
              questionResponse: questionResponse,
              appointmentId: "",
              encounterId: encounterId,
              questionnaire: values.questionnaireId,
              authorName: user?.name[0]?.text.trim(),
              authorType: "Practitioner",
              authorId: user["custom:practitioner_id"]
            }
            handleQuestionnaireResponse(payload)
              .then(async (resQuestionnair) => {
                localStorage.removeItem("firstName");
                localStorage.removeItem("lastName");
                if (resQuestionnair?.status === true) {
                  const questionnairInfo = {
                    questionnaireResponseId: {
                      reference: `QuestionnaireResponse/${resQuestionnair?.data?.id}`,
                    },
                    callerName: values?.questionResponse.find(
                      (obj) => obj?.tag === "CALLER"
                    )?.answer?.[0]?.answer,
                    preferredChannel: "phone",
                  };
                  if (isTagPresent("TELEPHONE")) {
                    questionnairInfo["callerNumber"] =
                      getValueQuestionnair("TELEPHONE");
                  }
                  if (isTagPresent("REASON")) {
                    questionnairInfo["intakeReason"] =
                      getValueQuestionnair("REASON");
                  }
                  if (
                    isTagPresent("RELATIONSHIP") &&
                    isTagPresent("SELFCALLING")
                  ) {
                    if (getValueQuestionnairRadio("SELFCALLING") === "Yes")
                      questionnairInfo["callerRelationship"] = "Self";
                    else
                      questionnairInfo["callerRelationship"] =
                        getValueQuestionnairDropDown("RELATIONSHIP");
                  }
                  // For Proceed with Call, set intakePriorityReason on intakeQuestions (used by queue ingest)
                  questionnairInfo["intakePriorityReason"] = "Proceed with Call";
                  let encounterPayload = {
                    patient: {
                      reference: `Patient/${values.patientId}`,
                      type: "Patient",
                      display: values?.patientName.trim(),
                    },
                    orgId: values?.orgId,
                    orgName: values?.orgName.trim(),
                    questionnairInfo,
                    requestedPeriod: {
                      start: encounteredData?.period?.start,
                      end: null,
                    },
                    practitionerId:
                      practitionerData?.link?.[0]?.target?.reference?.split(
                        "/"
                      )?.[1],
                    practitionerName: user?.name?.[0]?.text.trim(),
                    proceedWith: values?.howToProcced,
                    status: "in-progress-waitingroom",
                    encounterId: encounterId,
                    serviceLineId: values?.serviceLineId,
                    serviceLine: {
                      reference: `ServiceLine/${values?.serviceLineId}`,
                      display: values?.serviceLineName?.name || encounteredData?.serviceLine?.display,
                      type: "ServiceLine"
                    },
                    actor: {
                      reference: `Practitioner/${
                        practitionerData?.link?.[0]?.target?.reference?.split(
                          "/"
                        )?.[1]
                      }`,
                      display: user?.name?.[0]?.text.trim(),
                      type: "Practitioner",
                    },
                  };
                  if (getLocationQuestion) {
                    encounterPayload = {
                      ...encounterPayload,
                      patientLocation: scopeOfJurisdiction,
                    };
                  }
                  editEncounter(encounterPayload)
                    .then((resEncounter) => {
                      if (resEncounter.status === true) {
                        navigate("/app/phone-call-create", {
                          state: {
                            practitionerName: user?.name?.[0]?.text.trim(),
                            practitionerId: user["custom:unique_id"],
                            patientId: values?.patientId,
                            patientName: values?.patientName.trim(),
                            encounterId: encounterId,
                            currentUser: {
                              patient: { display: values?.patientName.trim() },
                            },
                            proceedWith: values?.howToProcced,
                            requestedPeriod: requestedPeriod,
                            questionnairInfo: questionnairInfo,
                            period: encounteredData.period,
                            callInitiatedFrom: "inboundCall",
                          },
                        });
                        handleShow();
                        setBtnLoading(false);
                      }
                    })
                    .catch((res) =>
                      failed(
                        res?.response?.data?.message ||
                          res?.response?.data?.error ||
                          res.message
                      )
                    )
                    .finally(() => setBtnLoading(false));
                }
              })
              .catch((res) =>
                failed(
                  res?.response?.data?.message ||
                    res?.response?.data?.error ||
                    res.message
                )
              )
              .finally(() => setBtnLoading(false));
          } else if (values?.howToProcced === "SCHEDULE") {
            let concatenatedName;
            let nameAnswer;
            let concatenatedAnswerExt;
            let telephoneAnswer;
            const nameQuestion = values.questionResponse.find(
              (question) => question.tag === "CALLER"
            );
            const telephoneQuestion = values.questionResponse.find(
              (question) => question.tag === "TELEPHONE"
            );
            if (nameQuestion) {
              nameAnswer = nameQuestion?.answer;
              concatenatedName =
                nameQuestion?.answer?.[1] !== undefined
                  ? nameAnswer[0]?.answer + " " + nameAnswer[1]?.answer
                  : nameAnswer[0]?.answer;
              let namePatient =
                getValueQuestionnairRadio("SELFCALLING") === "Yes"
                  ? values?.patientName
                  : concatenatedName;
              nameAnswer.splice(1, 1);
              nameAnswer[0].answer = namePatient
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");
              nameAnswer[0].required = true;
              nameAnswer[0].option = null;
              nameAnswer[0].value = null;
              nameAnswer[0].name = null;
            }
            if (telephoneQuestion) {
              telephoneAnswer = telephoneQuestion?.answer;
              concatenatedAnswerExt =
                telephoneQuestion?.answer?.[1] !== undefined
                  ? telephoneAnswer[0]?.answer +
                    " ext " +
                    telephoneAnswer[1]?.answer
                  : telephoneAnswer[0]?.answer;
              telephoneAnswer.splice(1, 1);
              telephoneAnswer[0].answer = concatenatedAnswerExt;
              telephoneAnswer[0].required = true;
              telephoneAnswer[0].option = null;
              telephoneAnswer[0].value = null;
              telephoneAnswer[0].name = null;
            }
            const questionResponse = values.questionResponse?.map((item) => ({
              id: item?.linkId,
              tag: item?.tag,
              questionId: item?.id  || null,
              question: item?.text.trim(),
              answer: (item?.tag === "CALLER" ? nameAnswer : item?.answer),
              questionType: item?.answerType,
              required: item?.required,
            }));
            setBtnLoading(true);
            let payload = {
              patientID: values?.patientId,
              encounterId: encounterId || "",
              questionResponse: questionResponse,
              appointmentId: "",
              questionnaire: values.questionnaireId,
              authorName: user?.name[0]?.text.trim(),
              authorType: "Practitioner",
              authorId: user["custom:practitioner_id"],
              id: questionnairResId
            }
            handleQuestionnaireResponse(payload)
              .then((res) => {
                setQuestionnairResId(res.data.id);
                setAppointmentModal(true);
                setBtnLoading(false);
              })
              .catch((res) => {
                failed(
                  res?.response?.data?.message ||
                    res?.response?.data?.error ||
                    res.message
                );
              })
              .finally(() => {
                setBtnLoading(false);
              });
          } else if (values?.howToProcced === "WAITING_ROOM") {
            setBtnLoading(true);
            let concatenatedName;
            let nameAnswer;
            let concatenatedAnswerExt;
            let telephoneAnswer;
            const nameQuestion = values.questionResponse.find(
              (question) => question.tag === "CALLER"
            );
            const telephoneQuestion = values.questionResponse.find(
              (question) => question.tag === "TELEPHONE"
            );
            if (nameQuestion) {
              nameAnswer = nameQuestion?.answer;
              concatenatedName =
                nameQuestion?.answer?.[1] !== undefined
                  ? nameAnswer[0]?.answer + " " + nameAnswer[1]?.answer
                  : nameAnswer[0]?.answer;
              let namePatient =
                getValueQuestionnairRadio("SELFCALLING") === "Yes"
                  ? values?.patientName
                  : concatenatedName;
              nameAnswer.splice(1, 1);
              nameAnswer[0].answer = namePatient
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");
              nameAnswer[0].required = true;
              nameAnswer[0].option = null;
              nameAnswer[0].value = null;
              nameAnswer[0].name = null;
            }
            if (telephoneQuestion) {
              telephoneAnswer = telephoneQuestion?.answer;
              concatenatedAnswerExt =
                telephoneQuestion?.answer?.[1] !== undefined
                  ? telephoneAnswer[0]?.answer +
                    " ext " +
                    telephoneAnswer[1]?.answer
                  : telephoneAnswer[0]?.answer;
              telephoneAnswer.splice(1, 1);
              telephoneAnswer[0].answer = concatenatedAnswerExt.trim();
              telephoneAnswer[0].required = true;
              telephoneAnswer[0].option = null;
              telephoneAnswer[0].value = null;
              telephoneAnswer[0].name = null;
            }
            const questionResponse = values.questionResponse?.map((item) => ({
              id: item?.linkId,
              tag: item?.tag,
              questionId: item?.id || null,
              question: item?.text,
              answer: item.answer,
              questionType: item?.answerType,
              required: item?.required,
            }));

            let payload = {
              patientID: values?.patientId,
              encounterId: "",
              questionResponse: questionResponse,
              appointmentId: "",
              encounterId: encounterId,
              questionnaire: values.questionnaireId,
              authorName: user?.name[0]?.text.trim(),
              authorType: "Practitioner",
              authorId: user["custom:practitioner_id"]
            }
            handleQuestionnaireResponse(payload)
              .then(async (resQuestionnair) => {
                localStorage.removeItem("firstName");
                localStorage.removeItem("lastName");
                if (resQuestionnair?.status === true) {
                  const questionnairInfo = {
                    questionnaireResponseId: {
                      reference: `QuestionnaireResponse/${resQuestionnair?.data?.id}`,
                    },
                    callerName: values?.questionResponse.find(
                      (obj) => obj?.tag === "CALLER"
                    )?.answer?.[0]?.answer,
                    preferredChannel: "phone",
                  };
                  if (isTagPresent("TELEPHONE")) {
                    questionnairInfo["callerNumber"] =
                      getValueQuestionnair("TELEPHONE");
                  }
                  if (isTagPresent("REASON")) {
                    questionnairInfo["intakeReason"] =
                      getValueQuestionnair("REASON");
                  }
                  if (
                    isTagPresent("RELATIONSHIP") &&
                    isTagPresent("SELFCALLING")
                  ) {
                    if (getValueQuestionnairRadio("SELFCALLING") === "Yes")
                      questionnairInfo["callerRelationship"] = "Self";
                    else
                      questionnairInfo["callerRelationship"] =
                        getValueQuestionnairDropDown("RELATIONSHIP");
                  }
                  let encounterPayload = {
                    patient: {
                      reference: `Patient/${values?.patientId}`,
                      type: "Patient",
                      display: values?.patientName.trim(),
                    },
                    orgId: values?.orgId,
                    orgName: values?.orgName.trim(),
                    questionnairInfo,
                    requestedPeriod: [
                      {
                        start: encounteredData?.period?.start,
                        end: null,
                      },
                    ],
                    practitionerId:
                      practitionerData?.link?.[0]?.target?.reference?.split(
                        "/"
                      )?.[1],
                    practitionerName: user?.name?.[0]?.text.trim(),
                    proceedWith: values?.howToProcced,
                    status: "in-progress-intake",
                    statusHistory: [{
                      status: "in-progress-intake",
                      actor: {
                        reference: practitionerData?.link?.[0]?.target?.reference,
                        display: practitionerData?.name?.[0]?.text.trim(),
                      },
                      period: {
                        start: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
                        end: null
                      }
                    }],
                    encounterId: encounterId,
                    serviceLineId: values?.serviceLineId,
                    serviceLine: {
                      reference: `ServiceLine/${values?.serviceLineId}`,
                      display: (values?.serviceLineName?.name || encounteredData?.serviceLine?.display).trim(),
                      type: "ServiceLine"
                    },
                    period: {
                      start: encounteredData?.period?.start,
                      end: null,
                    },
                    actor: {
                      reference: `Practitioner/${
                        practitionerData?.link?.[0]?.target?.reference?.split(
                          "/"
                        )?.[1]
                      }`,
                      display: user?.name?.[0]?.text.trim(),
                      type: "Practitioner",
                    },
                  };
                  if (getLocationQuestion) {
                    encounterPayload = {
                      ...encounterPayload,
                      patientLocation: scopeOfJurisdiction,
                    };
                  }
                  editEncounter(encounterPayload)
                    .then((resEncounter) => {
                      if (resEncounter.status === true) {
                        setWRModalData(encounterPayload);
                        setAddToWRModalShow(true);
                        //handleShow();
                        //setBtnLoading(false);
                      }
                    })
                    .catch((res) =>
                      failed(
                        res?.response?.data?.message ||
                          res?.response?.data?.error ||
                          res.message
                      )
                    )
                    .finally(() => setBtnLoading(false));
                }
              })
              .catch((res) =>
                failed(
                  res?.response?.data?.message ||
                    res?.response?.data?.error ||
                    res.message
                )
              )
              .finally(() => setBtnLoading(false));
          }
        }
      }
    },
  });

  // Warn on refresh/close : Warning only
  useEffect(() => {
    if (!modalShow || !encounterId) return;

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      return e.returnValue;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [modalShow, encounterId]);

  // Handle browser back button - Use handleClose()
  useEffect(() => {
    if (!modalShow || !encounterId) return;

    const handlePopState = async (e) => {
      window.history.pushState(null, '', window.location.href);
      await handleClose(encounterId);
    };

    window.history.pushState(null, '', window.location.href);

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [modalShow, encounterId]);

  const isTagPresent = (tagValue) =>
    formik?.values?.questionResponse?.some((item) => item.tag === tagValue);
  const getValueQuestionnair = (tagValue) =>
    formik?.values?.questionResponse?.find((item) => item.tag === tagValue)
      ?.answer?.[0]?.answer;
  const getValueQuestionnairDropDown = (tagValue) =>
    formik?.values?.questionResponse
      .find((obj) => obj?.tag === tagValue)
      ?.answer?.find((val) => val?.answer !== "")?.answer;
  const getValueQuestionnairRadio = (tagValue) =>
    formik?.values?.questionResponse
      .find((obj) => obj?.tag === tagValue)
      ?.answer?.find((val) => val?.answer === true)?.option;

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    formik.handleSubmit();
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  useEffect(() => {
    getOrganization(adminOrgs?.[0]?.id)
      .then(async (res) => {
        setIsWaitingRoom(res?.data?.isWaitingRoom);
        if (res.data?.assignedQuestionnaire) {
          //const response = await axios.get(
          //  `questionnaire/${res.data?.assignedQuestionnaire?.["telephone-intake"]}`
          //);
          //formik.setFieldValue("questionnaireId", response?.data?.id);
          //setQuestions(
          //  response?.data?.item?.map((item) => ({
          //    ...item,
          //    name: item?.text,
          //    value: item?.id,
          //  }))
          //);
          //formik.setFieldValue(
          //  "questionResponse",
          //  Questions?.map((item) => {
          //    const isTrue =
          //      item?.answerType === "freeText" ||
          //      item?.answerType === "dropDown";
          //    const isDropDown = item?.answerType === "dropDown";
          //    return {
          //      ...item,
          //      answer: item?.answerOption?.map((option) => {
          //        return {
          //          id: option?.id,
          //          required: item?.required,
          //          answer: isTrue ? "" : false,
          //          option: isTrue ? isDropDown ? option.text : null : option?.text, 
          //          value: isDropDown ? option.text : null,
          //          name: isDropDown ? option.text : null,
          //        };
          //      }),
          //    };
          //  })
          //);
        }
      })
      .catch((res) => {
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
        );
      });

    getOrganization()
      .then((res) => {
         if (res?.data) { 
          const allOrgs = res.data.map((org) => ({
            ...org,
            value: org.id,
          }));
          allOrgs.sort((a, b) => a.name.localeCompare(b.name));
          setOrganizations(allOrgs); 
          const adminOrg = allOrgs.find(
            (org) => org.id === adminOrgs[0]?.id
          ); 

          if (encounterId && encounteredData) {
            formik.setFieldValue("orgId", encounteredData?.serviceProvider?.reference?.split("/")?.[1]);
            formik.setFieldValue("orgName", encounteredData?.serviceProvider?.display);
          }
          else if (adminOrg) {
            formik.setFieldValue("orgId", adminOrg.id);
            formik.setFieldValue("orgName", adminOrg.name);
          }
        }
      })
      .catch((res) => {
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
        );
      });

    getSingleUser({
      id: user["custom:unique_id"],
      type: "Practitioner",
      userOrgId: adminOrgs?.[0]?.id
    })
      .then((res) => {
        setPractitionerData(res.data);
      })
      .catch((res) => {
        console.log("error fetching practioner list", res);
      });

    if (encounteredData?.serviceLineId) {
      formik.setFieldValue("serviceLineId", encounteredData?.serviceLineId)
    }
  }, []);

  useEffect(() => {
    formik.setFieldValue(
      "questionResponse",
      Questions?.map((item) => {
        const isTrue =
          item?.answerType === "freeText" || item?.answerType === "singleFreeText" || item?.answerType === "dropDown";
        const isDropDown = item?.answerType === "dropDown";
        return {
          ...item,
          answer: item?.answerOption?.map((option) => {
            return {
              id: option?.id,
              required: item?.required,
              answer: isTrue ? "" : false,
              option: isTrue ? isDropDown ? option.text : null : option?.text,
              value: isDropDown ? option.text : null,
              name: isDropDown ? option.text : null,
            };
          }),
        };
      })
    );
  }, [Questions]);

  useEffect(() => {
    if (formik?.values?.orgId) {
      getServiceLinesByOrgId(formik?.values?.orgId).then((res) => {
        if (res?.status === true) {
          let formattedSL = res?.data?.map((dataItem) => ({
              name: dataItem?.name,
              value: dataItem?.id,
              id: dataItem?.id
            }));
          formattedSL.sort((a, b) => a.name.localeCompare(b.name));
          setAvailableServiceLines(formattedSL)

          if (encounteredData?.serviceLineId) {
            let findMatch = res?.data?.find((item) => item?.id === encounteredData?.serviceLineId)
            if (findMatch?.name) {
              formik.setFieldValue("serviceLineName", findMatch)
            }
          } else if (formattedSL?.length === 1 && formattedSL?.[0]?.id) {
            formik.setFieldValue("serviceLineName", formattedSL?.[0])
            formik.setFieldValue("serviceLineId", formattedSL?.[0]?.id)
          } else {
            formik.setFieldValue("serviceLineId", '') 
          }
        }
      }).catch((res) => {
        failed(res?.error || res?.message || "Error getting Service Lines for Organization")
      })
    }
  }, [formik.values?.orgId])

  useEffect(() => {
    if (formik?.values?.serviceLineId && formik.values?.orgId) { 
      getServiceLineById(formik.values?.orgId, formik.values?.serviceLineId).then(async (res) => {
        const response = await getQuestionnaireById(res?.data?.intakeQuestionnaire, res?.data?.orgId);
        formik.setFieldValue("questionnaireId", response?.data?.id);
        
        // Store the questionnaire definition with enableWhen from APL rules
        setQuestionnaireDefinition(response?.data);
        
        const questions = response?.data?.item?.map((item) => ({
          ...item,
          name: item?.text,
          value: item?.id,
        }));
        setQuestions(questions);

        const questionResponse = questions?.map((item) => {
          const isTrue =
            item?.answerType === "freeText" || item?.answerType === "singleFreeText" ||
            item?.answerType === "dropDown";
          const isDropDown = item?.answerType === "dropDown";
          return {
            ...item,
            questionId: item?.id || item?.linkId || null, // This must match the id in enableWhen expression
            tag: item?.tag,
            questionType: item?.answerType,
            answerType: item?.answerType,
            answer: item?.answerOption?.map((option) => {
              return {
                id: option?.id,
                required: item?.required,
                answer: isTrue ? "" : false,
                option: isTrue ? isDropDown ? option.text : null : option?.text, 
                value: isDropDown ? option.text : null,
                name: isDropDown ? option.text : null,
              };
            }),
          };
        });
        
        formik.setFieldValue("questionResponse", questionResponse);
      }).catch((res) => {
        failed(
          res?.response?.data?.message ||
            res?.response?.data?.error ||
            res?.message || "Error getting Service Line Intake Questionnaire"
        );
      });
    }

  }, [formik.values?.serviceLineId, formik.values?.orgId])

  // Evaluate APL rules and filter visible questions - re-evaluate whenever questionResponse changes
  useEffect(() => {
    if (!questionnaireDefinition || !formik.values?.questionResponse || Questions.length === 0) {
      if (Questions.length > 0) {
        setVisibleQuestions(Questions.map(() => true));
      }
      return;
    }

    const visibility = Questions.map((question, idx) => {
      let questionnaireItem = null;
      
      questionnaireItem = questionnaireDefinition?.item?.find(q => 
        q.id === question.id && q.linkId === question.linkId
      );

      if (!questionnaireItem) {
        questionnaireItem = questionnaireDefinition?.item?.find(q => q.linkId === question.linkId);
      }

      if (!questionnaireItem) {
        questionnaireItem = questionnaireDefinition?.item?.find(q => q.id === question.id);
      }
      if (!questionnaireItem?.enableWhen) return true;
      const questionResponse = formik.values.questionResponse.map((item, index) => ({
        ...item,
        questionId: item.questionId || item.id || Questions[index]?.id || Questions[index]?.linkId || null,
        tag: item?.tag,
        questionType: item.questionType || item.answerType,
        answerType: item.answerType || item.questionType,
      }));
      
      return evaluateCondition(questionnaireItem.enableWhen.expression, questionResponse);
    });
    
    setVisibleQuestions(visibility);
  }, [questionnaireDefinition, Questions, questionResponseKey, formik.values.questionResponse]);


  useEffect(() => {
    if(formik.values?.orgId) {
      getOrganizationSettings(formik.values?.orgId)
        .then((res) => {
          setOrganizationSettings(res?.data);
        })
        .catch((res) => {
          failed(
            res?.response?.data?.message ||
              res?.response?.data?.error ||
              res?.message ||
              "Error getting organization settings"
          );
        });
    }
  }, [formik.values?.orgId]);

  // Watch for changes in answer values to trigger re-evaluation
  useEffect(() => {
    if (!formik.values?.questionResponse || Questions.length === 0) return;
    
    // Create a hash of all answer values to detect changes
    const answerHash = formik.values.questionResponse.map(q => {
      if (q.answerType === 'radio' || q.answerType === 'checkbox') {
        return q.answer?.filter(a => a.answer === true).map(a => a.option).join(',');
      } else {
        return q.answer?.[0]?.answer || '';
      }
    }).join('|');
    
    // Trigger re-evaluation when answers change
    const timer = setTimeout(() => {
      setQuestionResponseKey(prev => prev + 1);
    }, 50);

    return () => clearTimeout(timer);
  }, [formik.values.questionResponse?.map(q => {
    if (q.answerType === 'radio' || q.answerType === 'checkbox') {
      return q.answer?.filter(a => a.answer === true).map(a => a.option).join(',');
    } else {
      return q.answer?.[0]?.answer || '';
    }
  }).join('|'), Questions.length]);

  const handleOrgChange = (e) => {
    formik.setFieldValue("orgId", e.target.value);
    formik.setFieldValue(
      "orgName",
      organizations.find((org) => org.value === e.target.value).name
    );
    formik.setFieldValue("serviceLineId", '')
  };

  const handleServiceLineChange = (e) => {
    formik.setFieldValue("serviceLineId", e.target.value)
    let selectedSL = availableServiceLines?.find((item) => item?.id == e.target.value)
    formik.setFieldValue("serviceLineName", selectedSL)
  }

  const getAddedPatient = (addedData) => {
    setPatient(addedData);
  };

  const resetPatient = (data) => {
    setPatient(data);
  };

  // if no questionnaire response id, create a new one, otherwise, update
  const handleQuestionnaireResponse = async (payload) => {
    if (questionnairResId) 
      return editQuestionnaireResponse(questionnairResId, payload)
    else
      return createQuestionnaireResponse(payload);
  }

  const activeForm = () => {
    switch (activeStep) {
      case 0:
        return (
          <div>
          <Row>
            <Col>
              <SelectFiled
                formik={formik}
                options={organizations}
                fieldtype={"TextInput"}
                keyField={"orgId"}
                label={"Select Organization"}
                placeholder={"Select Organization"}
                required={true}
                onChange={handleOrgChange}
                readOnly={isOrgReadOnly}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <SelectFiled
                formik={formik}
                options={availableServiceLines}
                fieldtype={"TextInput"}
                keyField={"serviceLineId"}
                label={"Service Line"}
                placeholder={"Select Service Line"}
                required={true}
                onChange={handleServiceLineChange}
                readOnly={encounteredData?.serviceLineId ? true : false}
              />
            </Col>
          </Row>
          </div>

          
        );
      case 1:
        return (
          <>
            {Questions?.length > 0 ? (
              Questions?.map((question, index) => {
                // Only render if question is visible based on APL rules
                if (!visibleQuestions[index]) return null;
                
                return (
                  <Fragment key={index}>
                    {/* <h6>{question?.text}{question?.required ? <span style={{ color: "red" }}> *</span> : null}</h6> */}
                    <Fields
                      question={question}
                      Questions={Questions}
                      formik={formik}
                      propIndex={index}
                      setRadioValue={(val) => {
                        setRadioValue(val);
                        // Force re-evaluation after a short delay to allow formik to update
                        setTimeout(() => setQuestionResponseKey(prev => prev + 1), 0);
                      }}
                    />
                    {/* <div>{formik?.errors?.questionResponse?.[index] ? <div className="error-text">Required question</div> : null}</div> */}
                  </Fragment>
                );
              })
            ) : (
              <div className="error-text">
                Assign the questionnaire to proceed.
              </div>
            )}
          </>
        );
      case 2:
        return (
          <PatientSelection
            orgId={formik?.values?.orgId}
            formikInBoundCall={formik}
            handleAddPatient={() => setPatientModal(true)}
            patient={patient}
            resetPatient={resetPatient}
            onSearchLoadingChange={setBtnLoading}
          />
        );
      case 3:
        return (
          <div style={{ padding: "10px" }}>
            <Row>
              <Col
                style={{
                  border: "1px solid #c7c7c7",
                  padding: "10px",
                  borderRadius: "10px",
                  marginRight: "5px",
                }}
              >
                <label
                  style={{
                    display: "block",
                    cursor: "pointer",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <input
                    type="radio"
                    name="radio"
                    value={"COMPLETE_CALL"}
                    onChange={(e) =>
                      formik.setFieldValue("howToProcced", e.target.value)
                    }
                    style={{ marginRight: "5px" }}
                  />
                  Proceed with the call
                </label>
              </Col>
              {is_VirtualCareEnabled && <Col
                style={{
                  border: "1px solid #c7c7c7",
                  padding: "10px",
                  borderRadius: "10px",
                  marginRight: "5px",
                }}
              >
                <label
                  style={{
                    display: "block",
                    cursor: "pointer",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <input
                    type="radio"
                    name="radio"
                    value={"SCHEDULE"}
                    onChange={(e) =>
                      formik.setFieldValue("howToProcced", e.target.value)
                    }
                    style={{ marginRight: "5px" }}
                  />
                  Schedule an Appointment
                </label>
              </Col>}
              {isWaitingRoom ? (
                <Col
                  style={{
                    border: "1px solid #c7c7c7",
                    padding: "10px",
                    borderRadius: "10px",
                  }}
                >
                  <label
                    style={{
                      display: "block",
                      cursor: "pointer",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <input
                      type="radio"
                      name="radio"
                      value={"WAITING_ROOM"}
                      onChange={(e) =>
                        formik.setFieldValue("howToProcced", e.target.value)
                      }
                      style={{ marginRight: "5px" }}
                    />
                    Add to Waiting Room
                  </label>
                </Col>
              ) : null}
            </Row>
            <div>
              {formik?.errors?.howToProcced ? (
                <div className="error-text">{formik?.errors?.howToProcced}</div>
              ) : null}
            </div>
          </div>
        );
      default:
        return <Col></Col>;
    }
  };

  const handleClose = async (entryName) => {
    const confirmed = await getConfirmation({
      title: "Attention!",
      entryName,
      actionBtnTitle: "Yes",
      cancelBtnTitle: "No",
      actionFirst: true,
      message: "Are you sure you would like to cancel the encounter",
    });
    if (!confirmed) return;
    if(encounterId){
      if (confirmed) {
        let payload = {
          status: "cancelled",
          period: {
            start: encounteredData?.period?.start,
            end: moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
          },
          actor: {
            display: practitionerData?.name?.[0]?.text,
            reference: `Practitioner/${practitionerData?.id}`,
            type: "Practitioner"
          },
          class: "NULL"
        };
        setBtnLoading(true)
        return axios.put(`encounter/${encounterId}`, payload).then((res) => {
          if (res?.status === true) {
            success(res?.message)
            handleShow()
          }
        }).catch((res) => {
          failed(res?.message || "Error updating encounter")
        }).finally(() => setBtnLoading(false))
      }
    } else {
      handleShow()
    }
  }

  return (
    <>
      {patientModal && (
        <AddPatient
          formikInBoundCall={formik}
          modalShow={patientModal}
          handleShow={() => setPatientModal(false)}
          getAddedPatient={getAddedPatient}
        />
      )}
      {appointmentModal && (
        <BookAppointment
          questionnaireResponseId={questionnairResId}
          formikInBoundCall={formik}
          type="patient"
          modalShow={selectedPractitionerId ? {id: selectedPractitionerId }:appointmentModal}
          onHide={ () =>
            setAppointmentModal(false)
          }
          handleShow={() => {
            handleShow();
          }}
          encounterIdFromModal={encounteredData?.id}
        />
      )}
      {addToWRModalShow && (
        <AddToWaitingRoomModal
          data={WRModalData}
          onShow={addToWRModalShow}
          onHide={() => {
            setAddToWRModalShow(false);
          }}
          handleShow={() => handleShow()}
        />
      )}
      <Modal
        show={modalShow}
        onHide={() => handleClose(encounterId)}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdropClassName
        backdrop={"static"}
        dialogClassName="modal-xl-custom"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Create New Encounter
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box sx={{ width: "100%" }}>
            <Stepper activeStep={activeStep}>
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                // if (isStepOptional(index)) {
                //     labelProps.optional = (
                //     <Typography variant="caption">Optional</Typography>
                //     );
                // }
                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            {activeStep === steps.length ? (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  All steps completed - you&apos;re finished
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleReset}>Reset</Button>
                </Box>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <form
                  className="common-form border-fields"
                  style={{
                    border: "1px solid #c7c7c7",
                    padding: "10px",
                    borderRadius: "5px",
                    marginTop: "10px",
                  }}
                >
                  {activeForm()}
                </form>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                {activeStep !== 0 && (
                  <Button
                    variant="secondary"
                    disabled={btnLoading}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                  >
                    Previous
                  </Button>
                )}
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleNext} isLoading={btnLoading}>
                    {activeStep === steps.length - 1 ? "Proceed" : "Next"}
                  </Button>
                </Box>
              </React.Fragment>
            )}
          </Box>
        </Modal.Body>
      </Modal>
    </>
  );
}
